import AppRoutes from "./routes";
import ClarityScript from "./components/ClarityScript/ClarityScript";
import CognitoConfig from './cognitoConfig';
import '@aws-amplify/ui-react/styles.css';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
Amplify.configure(CognitoConfig);

function App() {
  return (
    <>
      <ClarityScript />
      <Authenticator hideSignUp={true} loginMechanisms={['email']} >
        {({ signOut, user }) => (
          <AppRoutes />
        )}
      </Authenticator>
    </>
  );
}

export default App;
